import { render, staticRenderFns } from "./MWidgetBatchReport.vue?vue&type=template&id=cdf2c1ae&scoped=true&lang=pug&"
import script from "./MWidgetBatchReport.vue?vue&type=script&lang=js&"
export * from "./MWidgetBatchReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf2c1ae",
  null
  
)

export default component.exports